export const ru = {
    'button-cancel': 'Отмена',
    'button-submit': 'Применить'
};
